import React from "react";
import LogoDark from "../assets/acebit-logo-white.svg";
import { FaLinkedin } from 'react-icons/fa';
import NavLink from "./navlink";
import { OPEN_CONSENT_EVENT } from "../constants/consent";
import { NAV_ITEMS, OFFICES } from "../constants/site";

const Footer = () => {
    return (
        <footer className="border-t border-white/5 bg-slate-950 text-slate-400">
            <div className="container-page py-12 sm:py-16">
                <div className="grid grid-cols-2 gap-10 md:grid-cols-12 md:gap-12">
                    <div className="col-span-2 flex flex-col gap-5 md:col-span-5">
                        <NavLink target="home">
                            <img src={LogoDark} alt="Acebit" className="w-36" />
                        </NavLink>
                        <p className="max-w-xs text-sm leading-relaxed">
                            Vi designar, bygger och automatiserar moderna nätverk.
                        </p>
                        <a
                            href="https://www.linkedin.com/company/acebit"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Acebit på LinkedIn"
                            className="w-fit text-slate-400 transition-colors duration-200 hover:text-white"
                        >
                            <FaLinkedin size={22} />
                        </a>
                    </div>

                    <div className="flex flex-col gap-4 md:col-span-3">
                        <h3 className="eyebrow !text-slate-500">Sidor</h3>
                        <ul className="flex flex-col gap-2 text-sm">
                            {[...NAV_ITEMS, { target: "contact", title: "Kontakt" }].map((item) => (
                                <li key={item.target}>
                                    <NavLink target={item.target} className="transition-colors duration-200 hover:text-white">
                                        {item.title}
                                    </NavLink>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="flex flex-col gap-4 md:col-span-4">
                        <h3 className="eyebrow !text-slate-500">Kontor</h3>
                        <ul className="flex flex-col gap-3 text-sm">
                            {OFFICES.map((office) => (
                                <li key={office.name}>
                                    <a href={office.maps} target="_blank" rel="noopener noreferrer" className="group flex flex-col">
                                        <span className="text-slate-200 transition-colors group-hover:text-sky-400">{office.name}</span>
                                        <span>{office.street}, {office.zip}</span>
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                <div className="mt-10 flex flex-col gap-3 border-t sm:mt-12 border-white/10 pt-6 text-xs sm:flex-row sm:items-center sm:justify-between">
                    <span>© {new Date().getFullYear()} Acebit AB</span>
                    <button
                        type="button"
                        onClick={() => window.dispatchEvent(new Event(OPEN_CONSENT_EVENT))}
                        className="w-fit transition-colors duration-200 hover:text-white"
                    >
                        Cookie-inställningar
                    </button>
                </div>
            </div>
        </footer>
    );
};
export default Footer;
